const { UNPROCESSABLE_ENTITY } = require('http-status-codes')
const { ErrorBase } = require('./ErrorBase')
const TRANSLATION_KEY = 'setting.companyProfile.addressErrorMessage'

class InvalidAddressError extends ErrorBase {
  constructor (message) {
    super(message, TRANSLATION_KEY, UNPROCESSABLE_ENTITY)

    this.name = 'InvalidAddressError'
  }
}
module.exports = {
  InvalidAddressError
}
